export const FETCH_CURRENT_ALERTS_INIT_ACTION =
  "FETCH_CURRENT_ALERTS_INIT_ACTION";
export const FETCH_CURRENT_ALERTS_SUCCESS_ACTION =
  FETCH_CURRENT_ALERTS_INIT_ACTION + "_SUCCESS";
export const FETCH_CURRENT_ALERTS_FAIL_ACTION =
  FETCH_CURRENT_ALERTS_INIT_ACTION + "_ERROR";

export const FETCH_APARTMENTS_INIT_ACTION = "FETCH_APARTMENTS__INIT_ACTION";
export const FETCH_APARTMENTS_SUCCESS_ACTION =
  FETCH_APARTMENTS_INIT_ACTION + "_SUCCESS";
export const FETCH_APARTMENTS_FAIL_ACTION =
  FETCH_APARTMENTS_INIT_ACTION + "_ERROR";

export const FETCH_SOCOETY_CONSUMPTION_INIT_ACTION =
  "FETCH_SOCOETY_CONSUMPTION_INIT_ACTION";
export const FETCH_SOCOETY_CONSUMPTION_SUCCESS_ACTION =
  FETCH_SOCOETY_CONSUMPTION_INIT_ACTION + "_SUCCESS";
export const FETCH_SOCOETY_CONSUMPTION_FAIL_ACTION =
  FETCH_SOCOETY_CONSUMPTION_INIT_ACTION + "_ERROR";

export const FETCH_PENDING_BILL_APARTMENT_INIT_ACTION =
  "FETCH_PENDING_BILL_APARTMENT_INIT_ACTION";
export const FETCH_PENDING_BILL_APARTMENT_SUCCESS_ACTION =
  FETCH_PENDING_BILL_APARTMENT_INIT_ACTION + "_SUCCESS";
export const FETCH_PENDING_BILL_APARTMENT_FAIL_ACTION =
  FETCH_PENDING_BILL_APARTMENT_INIT_ACTION + "_ERROR";

export const FETCH_BILL_DETAILS_INIT_ACTION = "FETCH_BILL_DETAILS_INIT_ACTION";
export const FETCH_BILL_DETAILS_SUCCESS_ACTION =
  FETCH_BILL_DETAILS_INIT_ACTION + "_SUCCESS";
export const FETCH_BILL_DETAILS_FAIL_ACTION =
  FETCH_BILL_DETAILS_INIT_ACTION + "_ERROR";

export const FETCH_COMMERCIAL_WATER_INIT_ACTION =
  "FETCH_COMMERCIAL_WATER_INIT_ACTION";
export const FETCH_COMMERCIAL_WATER_SUCCESS_ACTION =
  FETCH_COMMERCIAL_WATER_INIT_ACTION + "_SUCCESS";
export const FETCH_COMMERCIAL_WATER_FAIL_ACTION =
  FETCH_COMMERCIAL_WATER_INIT_ACTION + "_ERROR";

export const FETCH_MUNICIPAL_WATER_INIT_ACTION =
  "FETCH_MUNICIPAL_WATER_INIT_ACTION";
export const FETCH_MUNICIPAL_WATER_SUCCESS_ACTION =
  FETCH_MUNICIPAL_WATER_INIT_ACTION + "_SUCCESS";
export const FETCH_MUNICIPAL_WATER_FAIL_ACTION =
  FETCH_MUNICIPAL_WATER_INIT_ACTION + "_ERROR";

export const FETCH_GROUND_WATER_INIT_ACTION = "FETCH_GROUND_WATER_INIT_ACTION";
export const FETCH_GROUND_WATER_SUCCESS_ACTION =
  FETCH_GROUND_WATER_INIT_ACTION + "_SUCCESS";
export const FETCH_GROUND_WATER_FAIL_ACTION =
  FETCH_GROUND_WATER_INIT_ACTION + "_ERROR";

export const FETCH_RAIN_WATER_INIT_ACTION = "FETCH_RAIN_WATER_INIT_ACTION";
export const FETCH_RAIN_WATER_SUCCESS_ACTION =
  FETCH_RAIN_WATER_INIT_ACTION + "_SUCCESS";
export const FETCH_RAIN_WATER_FAIL_ACTION =
  FETCH_RAIN_WATER_INIT_ACTION + "_ERROR";

export const FETCH_SLAB_RATE_INIT_ACTION = "FETCH_SLAB_RATE_INIT_ACTION";
export const FETCH_SLAB_RATE_SUCCESS_ACTION =
  FETCH_SLAB_RATE_INIT_ACTION + "_SUCCESS";
export const FETCH_SLAB_RATE_FAIL_ACTION =
  FETCH_SLAB_RATE_INIT_ACTION + "_ERROR";

export const ADD_PRIMARY_RWAMEMBER_INIT_ACTION =
  "ADD_PRIMARY_RWAMEMBER_INIT_ACTION";
export const ADD_PRIMARY_RWAMEMBER_SUCCESS_ACTION =
  ADD_PRIMARY_RWAMEMBER_INIT_ACTION + "_SUCCESS";
export const ADD_PRIMARY_RWAMEMBER_FAIL_ACTION =
  ADD_PRIMARY_RWAMEMBER_INIT_ACTION + "_ERROR";

  export const FETCH_AGGREGATE_CONSUMPTION_INIT_ACTION = "FETCH_AGGREGATE_CONSUMPTION_INIT_ACTION";
 export const FETCH_AGGREGATE_CONSUMPTION_SUCCESS_ACTION =
  FETCH_AGGREGATE_CONSUMPTION_INIT_ACTION + "_SUCCESS";
export const FETCH_AGGREGATE_CONSUMPTION_FAIL_ACTION =
  FETCH_AGGREGATE_CONSUMPTION_INIT_ACTION + "_ERROR";